import { DateTime } from 'luxon';
import * as React from 'react';
import { FormCell } from 'ui-toolkit';
import TimeInputStyled from './TimeInput.styles';

export interface ITimeInputProps {
  inputValue: string | null;
  errorText?: string | null;
  placeHolder?: string;
  className?: string;
  label?: string;
  isRequired?: boolean;
  onChange: (time: string | null, error?: string | null) => void;
  onBlur?: (time: string | null, error?: string | null) => void;
}

export interface ITimeInputState {
  inputValue: string;
}

export class TimeInput extends React.Component<ITimeInputProps, ITimeInputState> {
  public static defaultProps: Partial<ITimeInputProps> = {
    isRequired: false,
    placeHolder: '12:00 PM',
  };

  public readonly state: ITimeInputState = {
    inputValue: this.getInputValue(this.props.inputValue),
  };

  public componentWillReceiveProps(newProps: ITimeInputProps) {
    if (newProps.inputValue !== this.props.inputValue) {
      this.setState({
        inputValue: this.getInputValue(newProps.inputValue),
      });
    }
  }

  public render() {
    return (
      <FormCell
        className={this.props.className}
        errorText={this.props.errorText}
        label={this.props.label}
        isRequired={this.props.isRequired}
      >
        <TimeInputStyled
          placeholder={this.props.placeHolder}
          value={this.state.inputValue}
          mask={'99:99 AM'}
          formatChars={{
            '*': '[A-Za-z0-9]',
            '9': '[0-9]',
            A: '[AaPp]',
            M: '[Mm]',
            a: '[A-Za-z]',
          }}
          onBlur={this.onTimeBlur}
          onChange={this.onTimeChange}
        />
      </FormCell>
    );
  }

  private getInputValue(inputValue: string | null): string {
    let dateTime = '';
    if (inputValue) {
      dateTime = DateTime.fromFormat(inputValue, 'hh:mm:ss').toLocaleString(DateTime.TIME_SIMPLE);
      if (dateTime.split(':')[0].length === 1) {
        dateTime = `0${dateTime}`;
      }
    }
    return dateTime;
  }

  private onTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.indexOf('_') === -1 && value.indexOf(':') !== -1 && value.indexOf(' ') !== -1) {
      const ISOTime = this.getTimeISO(value);
      this.props.onChange(ISOTime, null);
    }

    this.setState({ inputValue: value });
  };

  private onTimeBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    let newValue: string | null = null;
    let errorMessage: string | null = null;
    if (value.indexOf('_') !== -1) {
      errorMessage = 'Invalid time';
    } else if (value === '') {
      newValue = null;
    } else {
      newValue = this.getTimeISO(value);
    }
    if (!value && !errorMessage && this.props.isRequired) {
      errorMessage = `${this.props.label ? ` ${this.props.label}` : ''}cannot be blank`;
    }
    this.props.onBlur ? this.props.onBlur(newValue, errorMessage) : this.props.onChange(newValue, errorMessage);
  };

  private getTimeISO(value: string): string | null {
    let hour = Number(value.split(':')[0]);
    let minute = Number(value.split(':')[1].split(' ')[0]);
    const dayTime = value.split(':')[1].split(' ')[1].toLowerCase();
    if (dayTime === 'pm' && hour < 12) {
      hour = hour + 12;
    } else if (hour > 12) {
      hour = 12;
    } else if (minute > 59) {
      minute = 59;
    }
    return DateTime.utc(1, 1, 1, hour, minute).toISOTime({
      includeOffset: false,
      suppressMilliseconds: true,
    });
  }
}
